export default "__VITE_ASSET__DixO1tQ5__"